import queryString from "query-string";

function get_cid_url () {
    let { cid } = queryString.parse(window.location.search);
    if(cid===undefined) cid='';
    return cid;
}

export default get_cid_url;